import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { UnitType } from '../../../../../models/enums/unit-type.enum';
import { IceapiService } from '../../../../../services';
import { MeasurementService } from '../../../../../services/measurement.service';
import { DiagramInfo, DiagramMappings, ClampModel } from '../../../models';
import { DiagramDimensionValidationModel } from '../../../models/diagram-dimension-validation-model';

@Component({
    selector: 'app-diagram-dimensions',
    templateUrl: './diagram-dimensions.component.html',
    styleUrls: ['./diagram-dimensions.component.scss'],
    standalone: false
})
export class DiagramDimensionsComponent {
    @Input()
    set diagramInfo(value: DiagramInfo) {
        this._diagramInfo = value;
        this.loadDiagramData();
    }
    get diagramInfo(): DiagramInfo {
        return this._diagramInfo;
    }

    loading: boolean = false;
    diagramDimensions: DiagramDimensionValidationModel[];
    clampData: ClampModel;
    diagramMappings: Map<string, DiagramMappings>;
    private _diagramInfo: DiagramInfo;

    constructor(
        private iceapi: IceapiService,
        private measSvc: MeasurementService,
        private cd: ChangeDetectorRef,
        private user_utility: UserUtilityService
    ) {}

    async loadDiagramData() {
        if (this.diagramInfo.diagramId !== null || this.diagramInfo.name !== null) {
            await this.getDiagramDimensions();
            await this.getClampDimensionData();
        } else {
            this.diagramDimensions = [];
        }
    }

    async getDiagramDimensions() {
        if (this.diagramInfo != undefined) {
            await this.iceapi
                .getDiagramDimensionValidations(this.diagramInfo.diagramId, 'Clamp')
                .toPromise()
                .then((result) => {
                    if (result.success === true) {
                        this.loadDiagramMappings(result.response);
                        this.diagramDimensions = result.response;
                        return result;
                    }
                })
                .catch((e) => {
                    console.warn(e);
                });
        }
    }

    async getClampDimensionData() {
        await this.iceapi
            .getClamp(this.diagramInfo.clampId)
            .toPromise()
            .then((res) => {
                if (res.success === true) {
                    this.clampData = res.response;
                } else {
                    this.user_utility.errorModelPopup(res.message);
                }
            })
            .catch((e) => {
                console.warn(e);
            });

        if (this.clampData != null) {
            this.diagramMappings.get('clampBoltDiameter').value = this.measSvc.getUserPreferedValue(this.clampData.boltMaxDiameter, UnitType.DefaultLengthUnit)
                ? this.measSvc.getUserPreferedValue(this.clampData.boltMaxDiameter, UnitType.DefaultLengthUnit)
                : '0.00 ' + this.measSvc.getUserPreferedUnitSuffix(UnitType.DefaultLengthUnit);
            this.diagramMappings.get('clampBoltLength').value = this.measSvc.getUserPreferedValue(this.clampData.boltLength, UnitType.DefaultLengthUnit)
                ? this.measSvc.getUserPreferedValue(this.clampData.boltLength, UnitType.DefaultLengthUnit)
                : '0.00 ' + this.measSvc.getUserPreferedUnitSuffix(UnitType.DefaultLengthUnit);
            this.diagramMappings.get('clampID').value = this.measSvc.getUserPreferedValue(this.clampData.clampInsideDiameter, UnitType.DefaultLengthUnit)
                ? this.measSvc.getUserPreferedValue(this.clampData.clampInsideDiameter, UnitType.DefaultLengthUnit)
                : '0.00 ' + this.measSvc.getUserPreferedUnitSuffix(UnitType.DefaultLengthUnit);
            this.diagramMappings.get('clampBoltPitch').value = this.measSvc.getUserPreferedValue(this.clampData.boltPitch, UnitType.DefaultLengthUnit)
                ? this.measSvc.getUserPreferedValue(this.clampData.boltPitch, UnitType.DefaultLengthUnit)
                : '0.00 ' + this.measSvc.getUserPreferedUnitSuffix(UnitType.DefaultLengthUnit);
            this.diagramMappings.get('clampLugSeparation').value = this.measSvc.getUserPreferedValue(this.clampData.lugSeparation, UnitType.DefaultLengthUnit)
                ? this.measSvc.getUserPreferedValue(this.clampData.lugSeparation, UnitType.DefaultLengthUnit)
                : '0.00 ' + this.measSvc.getUserPreferedUnitSuffix(UnitType.DefaultLengthUnit);
            this.diagramMappings.get('clampWidth').value = this.measSvc.getUserPreferedValue(this.clampData.clampWidth, UnitType.DefaultLengthUnit)
                ? this.measSvc.getUserPreferedValue(this.clampData.clampWidth, UnitType.DefaultLengthUnit)
                : '0.00 ' + this.measSvc.getUserPreferedUnitSuffix(UnitType.DefaultLengthUnit);
            this.diagramMappings.get('clampLength').value = this.measSvc.getUserPreferedValue(this.clampData.overallLength, UnitType.DefaultLengthUnit)
                ? this.measSvc.getUserPreferedValue(this.clampData.overallLength, UnitType.DefaultLengthUnit)
                : '0.00 ' + this.measSvc.getUserPreferedUnitSuffix(UnitType.DefaultLengthUnit);
            this.diagramMappings.get('clampBoltCentre').value = this.measSvc.getUserPreferedValue(this.clampData.boltCentres, UnitType.DefaultLengthUnit)
                ? this.measSvc.getUserPreferedValue(this.clampData.boltCentres, UnitType.DefaultLengthUnit)
                : '0.00 ' + this.measSvc.getUserPreferedUnitSuffix(UnitType.DefaultLengthUnit);
            this.diagramMappings.get('clampBoltLugWidth').value = this.measSvc.getUserPreferedValue(this.clampData.boltLugWidth, UnitType.DefaultLengthUnit)
                ? this.measSvc.getUserPreferedValue(this.clampData.boltLugWidth, UnitType.DefaultLengthUnit)
                : '0.00 ' + this.measSvc.getUserPreferedUnitSuffix(UnitType.DefaultLengthUnit);
            this.diagramMappings.get('clampOD').value = this.measSvc.getUserPreferedValue(this.clampData.clampOutsideDiameter, UnitType.DefaultLengthUnit)
                ? this.measSvc.getUserPreferedValue(this.clampData.clampOutsideDiameter, UnitType.DefaultLengthUnit)
                : '0.00 ' + this.measSvc.getUserPreferedUnitSuffix(UnitType.DefaultLengthUnit);
        }
        this.cd.markForCheck();
    }

    loadDiagramMappings(dimensions: DiagramDimensionValidationModel[]) {
        this.diagramMappings = new Map<string, DiagramMappings>();
        dimensions.forEach((element) => {
            this.diagramMappings.set(element.key, new DiagramMappings(element.displayText, element.abbreviation));
        });
    }
}
